<template>
    <b-modal v-if="!loading" id="approval_form" ref="approval_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'New Signature Approval' : 'Edit Signature Approval' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="User" class="has-float-label">
                        <template v-slot:label>
                            <span>User <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateUser" v-model="selected.user" :options="users"
                                  :border-danger="'user_id' in errors"/>


                        <b-form-invalid-feedback :state="!'user_id' in errors"
                                                 v-text="'user_id' in errors ? errors.user_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Approved From" class="has-float-label">
                        <template v-slot:label>
                            <span>Approved From <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus"
                            mode="single"
                            v-model="datepicker.from"
                            @input="'from' in errors ? (delete errors.from) : ''"
                            :input-props="{ class:'form-control' + ('from' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'from' in errors"
                                                 v-text="'from' in errors ? errors.from[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Approved To" class="has-float-label">
                        <template v-slot:label>
                            <span>Approved To <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus"
                            popover-align="right"
                            mode="single"
                            v-model="datepicker.to"
                            @input="'to' in errors ? (delete errors.to) : ''"
                            :input-props="{ class:'form-control' + ('to' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'to' in errors"
                                                 v-text="'to' in errors ? errors.to[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('approval_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitApproval">Submit</state-button>

            <state-button v-else variant="primary" :click="updateApproval">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";

export default {
    name: "ApprovalFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit',
    ],

    data() {
        return {
            loading: true,
            selected: {
                user: []
            },
            datepicker: {
                from: null,
                to: null
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getApprovalForm',
            errors: 'getApprovalErrors',
            users: 'getSelectUsers'
        })
    },

    watch: {
        form() {
            if (this.edit) {
                this.selected.user = this.form.select_user;

                this.datepicker.from = moment(this.form.from).toDate();
                this.datepicker.to = moment(this.form.to).toDate();
            }
        },

        'datepicker.from'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.from = null;
            this.form.from = moment(date).format('YYYY-MM-DD');
        },
        'datepicker.to'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.to = null;
            this.form.to = moment(date).format('YYYY-MM-DD');
        },
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        resetForm() {
            this.$store.commit('setApprovalForm');

            this.selected = {
                user: []
            };

            this.datepicker = {
                from: null,
                to: null
            };
        },

        async getFormData() {
            await this.$store.dispatch('fetchSelectUsers');

            return this.loading = false;
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        submitApproval() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitApproval', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new approval!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('approval_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateApproval() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateApproval', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the approval!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('approval_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateUser(field) {
            if (field) {
                this.form.user_id = field.user_id;
            } else {
                this.form.user_id = '';
            }

            'user_id' in this.errors ? delete this.errors.user_id : '';
        },
    }
}
</script>

<style scoped>

</style>
